export const makeArray = (size: number) => Array(size).fill(1);
